import { render, staticRenderFns } from "./AppVersionsTable.vue?vue&type=template&id=6e90c848&"
import script from "./AppVersionsTable.vue?vue&type=script&lang=js&"
export * from "./AppVersionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports